//#region src/comments/threadstore/ThreadStore.ts
var e = class {
	auth;
	constructor(e) {
		this.auth = e;
	}
};
//#endregion
export { e as t };

//# sourceMappingURL=ThreadStore-ielskc3v.js.map